import { ReactNode } from 'react';
import FoldableFileSection from '@/components/common/FoldableFileSection';
import { CONTROLLER_CONFIG } from '@/lib/controllerConfig';
import { IPostAttachment } from '@/redux/post/post.d';
import { getAvailableControllers } from '@/redux/post/post.utils';
import { getAttachmentController } from '@/redux/post/post.slice.helpers';

/** G-code rows as one foldable section per controller, in CONTROLLER_ORDER;
 * only the first starts open. */
export default function GcodeByControllerRows<T extends IPostAttachment>({
  files,
  renderRow,
  cellClassName,
}: {
  files: T[];
  renderRow: (attachment: T) => ReactNode;
  cellClassName?: string;
}) {
  return (
    <>
      {getAvailableControllers(files).map((controller, index) => (
        <FoldableFileSection
          key={controller}
          label={`${CONTROLLER_CONFIG[controller].name} G-code`}
          files={files.filter(
            (file) => getAttachmentController(file) === controller
          )}
          defaultOpen={index === 0}
          renderRow={renderRow}
          cellClassName={cellClassName}
        />
      ))}
    </>
  );
}
